import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EventFinder/EventFinderHomeTypes";
import { VAMtypes } from "../_loadingHelpers/VAM";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import FinderBaseV2 from '../FinderBase/FinderBaseV2';

class EventFinderHome extends compose(FinderBaseV2, _TabEnabledMixin) {
    //templateString = template;

    private bookingFormatter(cell: StaticTable.StaticTableCell<VAMtypes.EvBookingEditorEntity>): boolean {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
            case "actions":
                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    //"innerHTML": this.translations["Generic_show"],
                    "class": "mds-button-base round w3-center sL3 mds-hover-dark w3-large",
                    "onclick": lang.hitch(this, "tableRowButton_click", cell.tableRow),
                    "title": this.translations["Generic_show"],
                }, node);

                this.UiModder.domConstruct.create("I", { "class": "far fa-calendar-alt" }, btn);
                return true;
                break;
            default:
                return false;
        }
    }

    private tableRowButton_click(rowData: StaticTable.StaticTableRow<VAMtypes.EvBookingEntity_Short>, group: any, evt: MouseEvent): void {

        // Details öffnent
        let entity = rowData.rowGroup.entity;
       
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinder(
            "EventFinder/GetFilterpanelOptions",
            "EventFinder/GetEventList",
            lang.hitch(this, this.tableRowButton_click),
            lang.hitch(this, this.bookingFormatter)
        );
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EventFinderHome);